/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FinishInvitationWithTwoFactorAuthenticationQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type FinishInvitationWithTwoFactorAuthenticationQuery = { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly displayName: string, readonly id: CK.AccountId, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly connectedClientAccounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId }>, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithInvitation> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUser> } }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId, readonly isCrawlingPaused: boolean, readonly isDiscovered: boolean, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly hasLimitedWebsitesAccess: boolean, readonly isOnboardingTourInProgress: boolean | null, readonly role: GraphQL.UserRole, readonly account: { readonly __typename?: 'Account', readonly canSignup: boolean, readonly currency: GraphQL.Currency | null, readonly displayName: string, readonly endUserPlan: GraphQL.EndUserPlan | null, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly id: CK.AccountId, readonly isCleanedUp: boolean, readonly isDemoAvailable: boolean, readonly isOutOfBand: boolean, readonly isPartner: boolean, readonly isProfileCompletenessAvailable: boolean, readonly isSuitableForTrialRevival: boolean, readonly isTrialBarDisplayed: boolean, readonly name: string | null, readonly phase: GraphQL.AccountPhase, readonly plan: GraphQL.AccountPlan | null, readonly state: GraphQL.AccountState, readonly tariff: string, readonly trialExpirationDate: CK.Timestamp | null, readonly type: GraphQL.AccountType, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }>, readonly legalDocumentRequirements: ReadonlyArray<{ readonly __typename?: 'LegalDocumentRequirement', readonly acceptedAt: CK.Timestamp | null, readonly documentType: GraphQL.LegalDocumentType, readonly requirement: GraphQL.LegalDocumentRequirementType }>, readonly premiumTrialOffer: { readonly __typename?: 'AccountPremiumTrialOffer', readonly durationInDays: number, readonly plan: GraphQL.AccountPlan } | null, readonly profileCompleteness: { readonly __typename?: 'AccountProfileCompleteness', readonly percentage: number, readonly tasks: ReadonlyArray<{ readonly __typename?: 'AccountProfileCompletenessTaskStatus', readonly isDone: boolean, readonly occurrences: number | null, readonly type: GraphQL.AccountProfileCompletenessTask }> } | null }, readonly user: { readonly __typename?: 'User', readonly displayName: string, readonly email: string, readonly firstName: string | null, readonly id: string, readonly initials: string, readonly isPlatformTourWebinarOfferingAvailable: boolean, readonly jobTitle: string | null, readonly lastName: string | null, readonly legacyId: string, readonly locale: string, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUser>, readonly platformTourWebinarOffering: GraphQL.PlatformTourWebinarOffering, readonly signature: string, readonly personalTweaks: { readonly __typename?: 'UserPersonalTweaks', readonly hiddenDashboardScopes: ReadonlyArray<Record<string, any>>, readonly pageDetailSourceMode: GraphQL.PageDetailSourceMode } | null }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite>, readonly problem: GraphQL.WebsiteProblem | null, readonly timeCreatedAt: CK.Timestamp }> }> } | null };


export const FinishInvitationWithTwoFactorAuthenticationDocument = gql`
    query FinishInvitationWithTwoFactorAuthentication {
  authenticatedSession {
    accounts {
      connectedClientAccounts {
        id
      }
      displayName
      id
      invitations {
        id
        permittedActions
      }
      memberships {
        account {
          id
        }
        user {
          id
          legacyId
          permittedActions
        }
      }
      permittedActions
      websites {
        displayName
        id
        isCrawlingPaused
        isDiscovered
        permittedActions
      }
    }
    memberships {
      account {
        canSignup
        currency
        displayName
        endUserPlan
        permittedActions
        features {
          feature
          id
        }
        id
        isCleanedUp
        isDemoAvailable
        isOutOfBand
        isPartner
        isProfileCompletenessAvailable
        isSuitableForTrialRevival
        isTrialBarDisplayed
        legalDocumentRequirements {
          acceptedAt
          documentType
          requirement
        }
        name
        phase
        plan
        premiumTrialOffer {
          durationInDays
          plan
        }
        profileCompleteness {
          percentage
          tasks {
            isDone
            occurrences
            type
          }
        }
        state
        tariff
        trialExpirationDate
        type
      }
      hasLimitedWebsitesAccess
      isOnboardingTourInProgress
      role
      user {
        displayName
        email
        firstName
        id
        initials
        isPlatformTourWebinarOfferingAvailable
        jobTitle
        lastName
        legacyId
        locale
        permittedActions
        personalTweaks {
          hiddenDashboardScopes
          pageDetailSourceMode
        }
        platformTourWebinarOffering
        signature
      }
      websites {
        displayName
        id
        pageCapacity
        permittedActions
        problem
        timeCreatedAt
      }
    }
  }
}
    `;

/**
 * __useFinishInvitationWithTwoFactorAuthenticationQuery__
 *
 * To run a query within a React component, call `useFinishInvitationWithTwoFactorAuthenticationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishInvitationWithTwoFactorAuthenticationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishInvitationWithTwoFactorAuthenticationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinishInvitationWithTwoFactorAuthenticationQuery(baseOptions?: Apollo.QueryHookOptions<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>(FinishInvitationWithTwoFactorAuthenticationDocument, options);
      }
export function useFinishInvitationWithTwoFactorAuthenticationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>(FinishInvitationWithTwoFactorAuthenticationDocument, options);
        }
export function useFinishInvitationWithTwoFactorAuthenticationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>(FinishInvitationWithTwoFactorAuthenticationDocument, options);
        }
export type FinishInvitationWithTwoFactorAuthenticationQueryHookResult = ReturnType<typeof useFinishInvitationWithTwoFactorAuthenticationQuery>;
export type FinishInvitationWithTwoFactorAuthenticationLazyQueryHookResult = ReturnType<typeof useFinishInvitationWithTwoFactorAuthenticationLazyQuery>;
export type FinishInvitationWithTwoFactorAuthenticationSuspenseQueryHookResult = ReturnType<typeof useFinishInvitationWithTwoFactorAuthenticationSuspenseQuery>;
export type FinishInvitationWithTwoFactorAuthenticationQueryResult = Apollo.QueryResult<FinishInvitationWithTwoFactorAuthenticationQuery, FinishInvitationWithTwoFactorAuthenticationQueryVariables>;